var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import * as authorization from "../../lib/authorization";
import '../../components/header';
import "./index.scss";
var MyModel = /** @class */ (function (_super) {
    __extends(MyModel, _super);
    function MyModel(root) {
        var _this = _super.call(this, "/api/AccessToken", root, {}) || this;
        var vm = {
            Username: "test1",
            Password: ko.observable("1")
        };
        _this.viewModel(vm);
        return _this;
    }
    MyModel.prototype.onValidating = function (d) {
        var viewModel = d;
        if (!viewModel.Username) {
            return "请输入用户名。";
        }
        if (!viewModel.Password()) {
            return "请输入密码。";
        }
        return null;
    };
    MyModel.prototype.save = function () {
        var viewModel = this.viewModel();
        // 如果还没有写好登录api，取消注释以下两行。
        // authorization.login(viewModel.Username,viewModel.Username, viewModel.Username);
        // return;
        _super.prototype.saveData.call(this, viewModel)
            .then(function (d) {
            viewModel.Password("");
            if (d === false)
                return; // token
            if (!d.data || !d.data.token)
                return window.popBox.show("用户名或密码错误。");
            //userId
            authorization.login(d.data.userId, d.data.nickname, d.data.token);
        });
    };
    return MyModel;
}(KnockoutModel));
var MyViewModel = /** @class */ (function (_super) {
    __extends(MyViewModel, _super);
    function MyViewModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasLayout = false;
        return _this;
    }
    MyViewModel.prototype.init = function () {
        this.c = new MyModel(this.container);
        this.c.bind();
    };
    MyViewModel.prototype.update = function (arg) {
        return Promise.resolve();
    };
    MyViewModel.prototype.onInitComplete = function () {
        // bar.init(document.querySelector("top-back-bar")); 
    };
    return MyViewModel;
}(Page));
export default MyViewModel;
